import { useState, useContext, useEffect } from "react";
import { UserAuthContext } from "../../App";
import React from "react";
import ProfileImg from "../../assets/BuyerProfile/ProfileDetail/DefaultImg.png";
import {
  updateProfileDetailsApi,
  userProfileDetailsApi,
} from "../../Apis/UserApi";
import { UpdateProfileImgSVG, SavePasswordSVG } from "../../assets/svg/allSvg";

const ProfileDetails = () => {
  const [photoUrl, setPhotoUrl] = useState(ProfileImg); // State to store the photo URL
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [gstNumber, setGSTNumber] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [editing, setEditing] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [updateDetails, setUpdateDetails] = useState();
  const [isPasswordEditable, setIsPasswordEditable] = useState(false);

  const { userUid } = useContext(UserAuthContext);

  // fetch user / buyer details API
  const fetchUserDetails = async () => {
    try {
      const response = await userProfileDetailsApi(userUid?.currentUser?.uid);
      const userData = response.userData;
      setName(userUid?.currentUser?.displayName);
      setEmail(userUid?.currentUser?.email);
      setPhone(userData.phoneNumber);
      setGSTNumber(userData.gstNumber);
      setBillingAddress(userData.billingAddress);
      setShippingAddress(userData.shippingAddress);
      setCity(userData.city);
      setCountry(userData.country);
      setState(userData.state);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    if (userUid?.currentUser?.uid)
      fetchUserDetails();
  }, [userUid?.currentUser?.uid]);

  // update user details
  const updateUserDetails = async () => {
    try {
      const responseUpdate = await updateProfileDetailsApi(
        userUid?.currentUser?.uid,
        {
          displayName: name,
          email: email,
          phoneNumber: phone,
          gstNumber: gstNumber,
          billingAddress: billingAddress,
          shippingAddress: shippingAddress,
          city: city,
          state: state,
          country: country,
        }
      );
      setUpdateDetails(responseUpdate);
      setEditing(false); // Set editing to false after update
    } catch (error) {
      console.log("Error updating the user details", error);
    }
  };

  useEffect(() => {
    updateUserDetails();
  }, [userUid?.currentUser?.uid]);

  const handlePasswordChange = (event) => {
    event.preventDefault();
    setEditing(false);
    setIsPasswordEditable(false);
    localStorage.setItem(
      "userDetails",
      JSON.stringify({ name, email, phone, photoUrl })
    );
  };

  const toggleEditing = () => {
    setEditing(!editing);
  };

  const handleChange = (event) => {
    // Handle file input change
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      // When the file is loaded, set the photo URL
      setPhotoUrl(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const togglePasswordEdit = () => {
    setIsPasswordEditable(!isPasswordEditable);
  };

  return (
    <div className="w-[1014px] h-[590px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col pt-[40px] pl-[30px] pr-[36px] pb-[14px]">
      <h2 className="w-[125px] h-[27px] text-black font-semibold text-[18px]">
        Profile Details
      </h2>

      <hr className="w-[204px] h-[3px] bg-[#FF6300] mt-[15px] rounded-full" />

      <div className="w-[948px] h-auto flex flex-col gap-y-[18px] overflow-y-scroll mt-[17px] pl-[3px] pr-[3px] py-[3px]">
        <div className="w-[940px] h-[83px] bg-white rounded-[5px] p-[18px] flex items-center justify-between drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <div className="flex gap-x-[9px] items-center justify-start w-auto">
            <div className="w-[56px] h-[47px]">
              <img
                src={photoUrl}
                alt="ProfileImg"
                className="w-[47px] h-[47px] rounded-full"
              />

              <button>
                <label className="w-[21px] h-[21px] flex items-center justify-center bg-white rounded-full overflow-hidden relative left-[30px] top-[-20px] cursor-pointer">
                  {UpdateProfileImgSVG}
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={handleChange}
                  />
                </label>
              </button>
            </div>

            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-auto h-[21px] font-semibold text-[14px]"
              readOnly={!editing}
            />
          </div>

          <button
            className="w-[129px] h-[45px] rounded-[5px] bg-[#FF6300] font-medium text-[14px] text-white"
            onClick={toggleEditing}
          >
            {" "}
            {editing ? "Submit" : "Edit Profile"}{" "}
          </button>
        </div>
        {editing && <button onClick={updateUserDetails}></button>}

        <div className="w-[940px] h-[133px] bg-white rounded-[5px] p-[20px] flex flex-col drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <h3 className="w-[161px] h-[23px] font-semibold text-[15px] text-black">
            Personal Information
          </h3>
          <div className="w-[190px] h-[24px] flex items-center justify-start">
            <hr className="w-[183px] h-[3px] bg-[#FF6300]" />
          </div>
          <div className="flex flex-row justify-between">
            <div className="flex flex-col w-[200px] items-start justify-start">
              <p className="w-[43px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Name
              </p>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-[200px] h-[21px] px-[4px] font-semibold text-[14px] border rounded-[5px] focus:outline-none focus:ring-0 focus:border-transparent"
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[300px] items-start justify-start">
              <p className="w-[57px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Email ID
              </p>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-[300px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] focus:outline-none focus:ring-0 focus:border-transparent"
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[135px] items-start justify-start">
              <p className="w-[105px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Phone Number
              </p>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="w-[135px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] focus:outline-none focus:ring-0 focus:border"
                readOnly={!editing}
              />
            </div>
          </div>
        </div>

        <div className="w-[940px] h-[203px] bg-white rounded-[5px] p-[20px] flex flex-col drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <h3 className="w-[161px] h-[23px] font-semibold text-[15px] text-black">
            Location Details
          </h3>
          <div className="w-[190px] h-[24px] flex items-center justify-start">
            <hr className="w-[183px] h-[3px] bg-[#FF6300]" />
          </div>
          <div className="flex flex-col w-full items-start justify-start">
            <p className="w-[58px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
              Address
            </p>
            <input
              className="w-[717px] h-[21px] font-semibold text-[14px] border rounded-[5px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
              type="text"
              value={billingAddress}
              onChange={(e) => setBillingAddress(e.target.value)}
              readOnly={!editing}
            />
          </div>
          <div className="flex flex-row justify-between mt-[24px]">
            <div className="flex flex-col w-[200px] items-start justify-start">
              <p className="w-[28px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                City
              </p>
              <input
                className="w-[200px] h-[21px] font-semibold text-[14px] rounded-[5px] px-[4px] border bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[250px] items-start justify-start">
              <p className="w-[37px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                State
              </p>
              <input
                className="w-[250px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={state}
                onChange={(e) => setState(e.target.value)}
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[120px] items-start justify-start">
              <p className="w-[57px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Country
              </p>
              <input
                className="w-[120px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent
          focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                readOnly={!editing}
              />
            </div>
          </div>
        </div>

        <div className="w-[940px] h-auto bg-white rounded-[5px] p-[20px] flex flex-col drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <h3 className="w-[161px] h-[23px] font-semibold text-[15px] text-black">
            Company Details
          </h3>
          <div className="w-[190px] h-[24px] flex items-center justify-start">
            <hr className="w-[156px] h-[3px] bg-[#FF6300]" />
          </div>
          <div className="flex flex-row justify-between mt-[24px] w-[615px]">
            <div className="flex flex-col w-[200px] items-start justify-start">
              <p className="w-[171px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Company Name
              </p>
              <input
                className="w-[200px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                // defaultValue="ABC Company Pvt. Ltd."
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[250px] items-start justify-start">
              <p className="w-[89px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                GST Number
              </p>
              <input
                className="w-[250px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={gstNumber}
                onChange={(e) => setGSTNumber(e.target.value)}
                readOnly={!editing}
              />
            </div>
          </div>
          <div className="flex flex-col w-full items-start justify-start mt-[23px]">
            <p className="w-[58px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
              Address
            </p>
            <input
              className="w-[717px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
              type="text"
              value={shippingAddress}
              onChange={(e) => setShippingAddress(e.target.value)}
              readOnly={!editing}
            />
          </div>
          <div className="flex flex-row justify-between mt-[24px]">
            <div className="flex flex-col w-[200px] items-start justify-start">
              <p className="w-[28px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                City
              </p>
              <input
                className="w-[200px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[5px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[250px] items-start justify-start">
              <p className="w-[37px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                State
              </p>
              <input
                className="w-[250px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={state}
                onChange={(e) => setState(e.target.value)}
                readOnly={!editing}
              />
            </div>
            <div className="flex flex-col w-[120px] items-start justify-start">
              <p className="w-[57px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Country
              </p>
              <input
                className="w-[120px] h-[21px] font-semibold text-[14px] border rounded-[5px] px-[4px] bg-transparent focus:outline-none focus:ring-0 focus:border-transparent"
                type="text"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
                readOnly={!editing}
              />
            </div>
          </div>
        </div>

        <div className="w-[940px] h-auto bg-white rounded-[5px] p-[20px] flex flex-col drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
          <h3 className="w-[101px] h-[23px] font-semibold text-[15px] text-black">
            My Password
          </h3>
          <div className="w-[190px] h-[24px] flex items-center justify-start">
            <hr className="w-[125px] h-[3px] bg-[#FF6300]" />
          </div>
          <div className="flex flex-row justify-between h-[60px] w-full">
            <div className="flex flex-col w-[200px] items-start justify-end">
              <p className="w-[126px] h-[21px] font-medium text-[14px] text-[#A6A6A6]">
                Current Password
              </p>
              <input
                className="w-[153px] h-[21px] font-semibold text-[14px] focus:outline-none focus:ring-0 focus:border-transparent"
                type="password"
                defaultValue="**********"
                readOnly={!isPasswordEditable}
              />
            </div>
            <button
              className="w-[174px] h-[42px] rounded-[5px] border flex items-center justify-center gap-x-[10px]"
              onClick={
                isPasswordEditable ? handlePasswordChange : togglePasswordEdit
              }
            >
              {isPasswordEditable ? (
                ""
              ) : (
                SavePasswordSVG
              )}
              <p className="w-[129px] h-[21px] font-medium text-black text-[14px]">
                {isPasswordEditable ? "Save Password" : "Change Password"}
              </p>
            </button>
          </div>
          {isPasswordEditable && (
            <form
              onSubmit={handlePasswordChange}
              className="flex flex-col w-[200px] items-start justify-end"
            >
              <p className="w-[126px] h-[21px] font-medium text-[14px] text-[#A6A6A6] my-3">
                New Password
              </p>
              <input
                className="w-[153px] h-[21px] font-semibold text-[14px] focus:outline-none focus:ring-0 focus:border-transparent"
                type="password"
                name="newPassword"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                required
              />
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
